import { Box } from "@mui/material";
import { useState } from "react";
import "./App.css";
import Map from "./components/Map";
import Rankings from "./components/Rankings";
import Coffee from "./Coffee";

function App() {
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [map, setMap] = useState(null);

  return (
    <Box>
      <Map setMap={setMap} setIsMapLoaded={setIsMapLoaded} />
      <Rankings mapRef={map} isMapLoaded={isMapLoaded} />
      <Coffee isMapLoaded={isMapLoaded} />
    </Box>
  );
}

export default App;
